const restDocUrl = (projectId, docPath) =>
  `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/${docPath}`;

const encodeValue = (value) => {
  if (value === null) return { nullValue: null };
  if (typeof value === 'boolean') return { booleanValue: value };
  if (typeof value === 'string') return { stringValue: value };
  if (typeof value === 'number') {
    return Number.isInteger(value)
      ? { integerValue: String(value) }
      : { doubleValue: value };
  }
  if (Array.isArray(value)) {
    return { arrayValue: { values: value.map(encodeValue) } };
  }
  if (typeof value === 'object') {
    const fields = {};
    Object.entries(value).forEach(([key, nested]) => {
      if (nested === undefined) return;
      fields[key] = encodeValue(nested);
    });
    return { mapValue: { fields } };
  }
  return { stringValue: String(value) };
};

export const jsToFirestoreFields = (obj) => {
  const fields = {};
  Object.entries(obj || {}).forEach(([key, value]) => {
    if (value === undefined) return;
    fields[key] = encodeValue(value);
  });
  return fields;
};

// Convert dotted SDK-style patches (`todoMap.123`) into a nested document plus
// updateMask so a Safari SDK hang can still persist a single quest.
export const restPatchFromUpdates = (updates) => {
  const nested = {};
  const mask = [];
  Object.entries(updates || {}).forEach(([key, value]) => {
    if (key === '_calorieMemoryRemove' || value === undefined) return;
    if (key.startsWith('todoMap.')) {
      const id = key.slice('todoMap.'.length);
      nested.todoMap = nested.todoMap || {};
      nested.todoMap[id] = value;
      mask.push(`todoMap.\`${id}\``);
      return;
    }
    nested[key] = value;
    mask.push(key);
  });
  return { nested, mask };
};

export const patchFirestoreDocRest = async ({ projectId, docPath, token, updates }) => {
  const { nested, mask } = restPatchFromUpdates(updates);
  if (!mask.length) return false;
  const params = new URLSearchParams();
  mask.forEach((path) => params.append('updateMask.fieldPaths', path));
  const res = await fetch(`${restDocUrl(projectId, docPath)}?${params.toString()}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ fields: jsToFirestoreFields(nested) })
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Firestore REST ${res.status}${text ? `: ${text.slice(0, 180)}` : ''}`);
  }
  return true;
};
